import React from "react";
import { StyledSkeleton } from "./styledPersonalPurchase";
import { StyledCard } from "../../../components/public/purchase/personalPurchase/cards/styledPersonalPurchaseCard";
import { SkeletonWrapper } from "../payment/styledPaymentPage";
const PersonalPurchaseSkeleton = ({className}) => {
  return (
    <StyledCard className={`pt-5 mx-auto ${className}`}>
      <SkeletonWrapper className="mt-1">
        <StyledSkeleton
          width={100}
          height={70}
          variant="rounded"
          className="mx-auto"
        />
        <StyledSkeleton width={100} variant="h3" className="mx-auto" />
        <StyledSkeleton width={150} height={60} className="mx-auto mx-auto" />
      </SkeletonWrapper>
    </StyledCard>
  );
};

export default PersonalPurchaseSkeleton;
